<template>
  <button @click="action">
    <span class="pause" v-if="!isPaused">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
      >
        <rect
          x="39"
          y="29"
          width="7.61905"
          height="40"
          fill="#D9D9D9"
          fill-opacity="0.5"
        />
        <rect
          x="53.2857"
          y="29"
          width="7.61905"
          height="40"
          fill="#D9D9D9"
          fill-opacity="0.5"
        />
      </svg>
    </span>
    <span class="play" v-else>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
      >
        <path
          d="M70 50L40 67.3205L40 32.6795L70 50Z"
          fill="#D9D9D9"
          fill-opacity="0.5"
        />
      </svg>
    </span>
  </button>
</template>

<script>
export default {
  name: "PlayPause",
  props: ["action", "isPaused"],
};
</script>

<style scoped>
button {
  cursor: pointer;
  border: none;
  position: absolute;
  z-index: 1;
  background: rgba(217, 217, 217, 0.3);
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>